import { EyeTrackingContainer as EyeTrackingContainerComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const EyeTrackingContainer = () => {
    const {
        eyeTrackingContainerData,
        isFetchingEyeTrackingContainer,
        isErrorEyeTrackingContainer,
    } = useSessionDetailsContext();

    if (isFetchingEyeTrackingContainer) {
        return <ContentLoader height="23.5rem" />;
    }

    if (isErrorEyeTrackingContainer && !isFetchingEyeTrackingContainer) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="20.5rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <EyeTrackingContainerComponent
            data={eyeTrackingContainerData}
            isLoading={isFetchingEyeTrackingContainer}
        />
    );
};

export default EyeTrackingContainer;
